var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicateShipmentWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.32985 1.09342C3.44229 0.967046 3.6032 0.894775 3.77214 0.894775H8.85944C9.02838 0.894775 9.18929 0.967046 9.30173 1.09342L12.4813 4.66721C12.5781 4.77601 12.6316 4.91669 12.6316 5.06247V7.55385C12.6316 7.88185 12.3663 8.14775 12.039 8.14775C11.7117 8.14775 11.4464 7.88185 11.4464 7.55385V5.65637H1.18517V13.3912H5.19572C5.52299 13.3912 5.7883 13.6571 5.7883 13.9851C5.7883 14.3131 5.52299 14.579 5.19572 14.579H0.592584C0.265309 14.579 0 14.3131 0 13.9851V5.06247C0 4.91669 0.0534931 4.77601 0.150293 4.66721L3.32985 1.09342ZM1.91492 4.46856H5.72321V2.08259H4.0377L1.91492 4.46856ZM6.90837 2.08259V4.46856H10.7167L8.59388 2.08259H6.90837Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1406 9.31592C10.9716 9.31592 10.8107 9.38819 10.6983 9.51457L7.62463 12.9693C7.47176 13.0548 7.36842 13.2183 7.36842 13.4059V13.4797C7.36841 13.481 7.36841 13.4823 7.36841 13.4836V22.4062C7.36841 22.4075 7.36841 22.4089 7.36842 22.4102V22.5002C7.36842 22.7763 7.59228 23.0002 7.86842 23.0002H19.5C19.7761 23.0002 20 22.7763 20 22.5002V13.4059C20 13.2183 19.8966 13.0548 19.7437 12.9693L16.6701 9.51457C16.5577 9.38819 16.3968 9.31592 16.2278 9.31592H11.1406ZM12.7727 21.8502C12.7078 21.8257 12.6375 21.8123 12.5641 21.8123H8.55358V14.0775H18.8148V15.975C18.8148 16.0459 18.8272 16.114 18.85 16.1771V21.8502H12.7727ZM13.0916 12.8897H9.28333L11.4061 10.5037H13.0916V12.8897ZM14.2768 12.8897V10.5037H15.9623L18.0851 12.8897H14.2768Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateShipmentWhite);
export default __webpack_public_path__ + "static/media/DuplicateShipmentWhite.e85103bb253af89e91fdcd663110e2fd.svg";
export { ForwardRef as ReactComponent };